import React, { FC } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BoxStatuses, RequirementStatusType } from 'src/models/procurements/Tender/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faCheckCircle, faTimesCircle, faBoxOpenFull } from '@fortawesome/pro-light-svg-icons';

export const Footnote: FC = () => {
  const { t } = useTranslation();
  return (
    <section className={styles.footnote}>
      <h4 className={styles.title}>
        <FontAwesomeIcon icon={faBoxOpenFull} />
        {t('DetailsPage.shorthand')}
      </h4>
      <ul className={styles.list}>
        <li className={styles.item}>
          <h5 className={styles.itemTitle}>{t('DetailsPage.boxStatuses')}</h5>
          <ul className={classNames(styles.statuses, styles.boxStatuses, styles.content)}>
            <li className={styles.status}>
              <FontAwesomeIcon icon={faTimesCircle} className={classNames(styles.statusIcon, styles.notfulfill)} />
              <span className={styles.desc}>{t(`DetailsPage.BoxStatuses.${BoxStatuses.NotFulfill}`)}</span>
            </li>
            <li className={styles.status}>
              <FontAwesomeIcon icon={faQuestionCircle} className={classNames(styles.statusIcon, styles.unsure)} />
              <span className={styles.desc}>{t(`DetailsPage.BoxStatuses.${BoxStatuses.Unsure}`)}</span>
            </li>
            <li className={styles.status}>
              <FontAwesomeIcon icon={faCheckCircle} className={classNames(styles.statusIcon, styles.fulfill)} />
              <span className={styles.desc}>{t(`DetailsPage.BoxStatuses.${BoxStatuses.Fulfill}`)}</span>
            </li>
          </ul>
        </li>
        <li className={styles.item}>
          <h5 className={styles.itemTitle}>{t('DetailsPage.requirementStatuses')}</h5>
          <ul className={classNames(styles.statuses, styles.requirementStatuses, styles.content)}>
            {Object.values(RequirementStatusType).map(value => (
              <li className={styles.status} key={value}>
                <span className={classNames(styles.requirementIcon, styles[value])} />
                <span className={styles.desc}>{t(`DetailsPage.RequirementStatusType.${value.toString()}`)}</span>
              </li>
            ))}
          </ul>
        </li>
        <li className={styles.item}>
          <h5 className={styles.itemTitle}>{t('DetailsPage.lots')}</h5>
          <p className={styles.content}>
            {t('DetailsPage.lotsDesc')} {'"'}
            {t('Common.title')}
            <sup>1</sup>
            {'"'}
          </p>
        </li>
      </ul>
    </section>
  );
};

export default Footnote;
